import "./dashboard-ui.css";

/**
 * Page title bar: small uppercase eyebrow + title on the left, an optional
 * period badge and action buttons (children) on the right.
 */
export default function PageHeader({ eyebrow, title, periodLabel, children }) {
  return (
    <div className="page-header dashboard-page-header flex-wrap align-items-center">
      <div className="header-left">
        {eyebrow && <div className="page-eyebrow">{eyebrow}</div>}
        <h4 className="mb-0 font-weight-bold text-dark">{title}</h4>
      </div>
      <div className="header-right d-flex flex-wrap align-items-center gap-2 mt-2 mt-lg-0">
        {periodLabel && (
          <span className="period-badge variant-gold">
            <i className="mdi mdi-calendar-range"></i> {periodLabel}
          </span>
        )}
        {children}
      </div>
    </div>
  );
}
